import { changeColorCodeToHex } from '@sds-system/system';
import type { CSSStyledProps, GetStyles } from '@sds-system/types';

export const getCSSStyles: GetStyles<CSSStyledProps> = ({ css, theme }) => {
  return {
    ...(css && typeof css === 'function'
      ? (changeColorCodeToHex(css(theme), theme) as object)
      : typeof css === 'object'
        ? (changeColorCodeToHex(css, theme) as object)
        : {}),
  };
};
